module.exports = __webpack_public_path__ + "img/stock6.bc944b5f.png";